import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { ExpenseClaimPaymentMethod, ExpenseCurrencyGroup } from 'app/core/models/expense.model';
import { AuthService } from "../../../../core/services/auth.service";
import { Permissions } from "../../../../core/constants/permissions";

@Component({
  selector: 'app-expense-caxton-details-head',
  templateUrl: './expense-caxton-details-head.component.html',
  styleUrls: ['./expense-caxton-details-head.component.scss']
})
export class ExpenseCaxtonDetailsHeadComponent implements OnInit {
  @Input() expense: ExpenseCurrencyGroup;
  @Input() dataLoaded: boolean;
  @Output() searchFilter: EventEmitter<{ id: string, label: string }> = new EventEmitter<{ id: string, label: string }>();
  @Output() trialFilter: EventEmitter<{ id: string, label: string }> = new EventEmitter<{ id: string, label: string }>();
  trialText: string;

  ExpenseClaimPaymentMethod = ExpenseClaimPaymentMethod;

  protected readonly authService = inject(AuthService);

  ngOnInit(): void {
    if(this.expense){
      this.setTrialText();
    }
  }

  private setTrialText() {
    this.trialText = this.expense.trialNickname ?
      `${this.expense.trialCode} ${this.expense.trialNickname} - ${this.expense.trialOpportunityNumber}` :
      `${this.expense.trialCode} ${this.expense.trialOpportunityNumber}`;
  }

  getPatientAddress(address: string | null, country: string | null): string {
    const formattedAddress = address ?? '';
    const lastTwoCharsOfAddress = formattedAddress.slice(-2);

    return country && country !== '' && country !== lastTwoCharsOfAddress
      ? `${formattedAddress}, ${country}`
      : formattedAddress;
  }

  filterExpenses(){
    this.searchFilter.emit({
      id: this.expense.patientId,
      label: `${this.expense.trialCode} | ${this.expense.patientCode} - ${this.expense.patientName}`
    });
  }

  filterByTrial(){
    this.trialFilter.emit({ id: this.expense.trialId, label: this.expense.trialCode });
  }

  protected readonly Permissions = Permissions;
}
